import Preset, { AtomisablePreset } from 'domain/entity/preset';

export type Features = Feature[];

export type BusinessInsightGroup = {
    type: string;
    label: string;
};

export type BusinessInsight = {
    type: string;
    feature: string;
    label: string;
    description?: string;
    group?: BusinessInsightGroup;
};

export default class Feature {
    constructor(
        readonly name: string,
        readonly key: string,
        readonly presets: Preset[],
        readonly atomisablePresets: AtomisablePreset[],
        readonly businessInsights: BusinessInsight[] = []
    ) {}
}
